import { checkEnvironment } from '@saviynt/common';

const getTcodesApiUrl = () => {
  const { PAMMS_API_URL } = checkEnvironment();

  return `${PAMMS_API_URL}/privilegedinstance/tcodes`;
};

export default getTcodesApiUrl;
